import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Modal from 'shared/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';

import {
  formatCurrency,
  formatPercent
} from 'shared/services/PriceService';

import {
  getSelectedCalculations
} from 'shared/selectors/cartSelectors';

const styles = () => ({
  discountGuideH1: {
    fontSize: '1.5rem'
  },
  savings: {
    fontStyle: 'oblique'
  },
  ...modalStyles()
});

class PriceGuide extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    const { classes, pricingModel, currency, calculations, purchases, settings } = this.props;

    if (!calculations) {
      return null;
    }

    const style = {
      background: '#14546e',
      color: '#fff'
    }

    let liStyle = {
      width: '100%',
      marginBottom: '1rem',
      fontWeight: 500
    }

    let discounts;
    if (this.props.discounts) {
      discounts = this.props.discounts.map(({message: {id, values}}) => ((
        <li style={liStyle}>
          <FormattedMessage {...withValues(messages[id], Object.assign(values, {"show_change": settings.show_change}))} />
        </li>
      )));
    }

    let instr = null;
    if (pricingModel !== 3 && discounts) {
      instr = (
        <p style={{marginBottom: '1.5rem'}}>
          <FormattedMessage {...messages.kiosk_price_guide_instructions} />
        </p>
      );
    }

    let boughtAll = false;
    for (let purchase of purchases) {
      if (purchase.buy_all_applied) {
        boughtAll = true;
        break;
      }
    }

    let standardPrice;
    if (boughtAll) {
      standardPrice = messages.kiosk_price_guide_instructions_unlocked;
    } else {
      standardPrice = withValues(messages.kiosk_price_guide_instructions_standard_price, {
        price: calculations.price_per_unit,
        currency,
        show_change: settings.show_change,
      });
    }

    return (
      <Modal disableScrollbar={true}
	isOpen={this.props.open}
	close={this.props.onClose.bind(this)}>
	<div className={classes.modalOverlay} onClick={this.props.onClose.bind(this)}></div>
	<div className={classes.modal} style={style}>
	  <CloseIcon className={classes.modalCloseIcon} onClick={this.props.onClose.bind(this)} />
	  <div>
            <h1 className={classes.discountGuideH1}>
              <FormattedMessage {...messages.kiosk_price_guide_header} />
            </h1>
	    <hr />
	    {instr}
	    <ul style={{listStyleType: 'none', padding: '0 0 0 1rem', textAlign: 'left', listStyleType: 'square'}}>
              <li style={liStyle}>
                <FormattedMessage {...standardPrice} />
              </li>
	      {discounts}
	    </ul>
	  </div>
	</div>
      </Modal>
    );

  }
}

const mapStateToProps = state => ({
  calculations: getSelectedCalculations(state),
  pricingModel: state.cartReducer.calculations.pricing_model,
  currency: state.cartReducer.calculations.currency,
  discounts: state.cartReducer.calculations.discounts,
  purchases: state.cartReducer.purchases,
  settings: state.kioskReducer.settings,
});

export default connect(mapStateToProps, { })(withStyles(styles)(PriceGuide));
